import { PortalRequest as request } from "@/utils/request";

// 我的咨询列表
export const getConsultList = (params, data) => {
  return request({
    url: "/user-biz/consult/list",
    method: "post",
    params,
    data,
  });
};
// 提交咨询
export const consultAdd = (data) => {
  return request({
    url: "/user-biz/consult/add",
    method: "post",
    data,
  });
};
